export class CallLogModel {
    id = 0;

    callLogInteractionTypeId = null;

    callDirectionId = null;

    callDispositionId = null;

    dispatchOfficeId = null;

    customerCompanyId = null;

    customerContactId = null;

    contactCategoryId = null;

    contactFirstName = '';

    contactLastName = '';

    contactPhoneNumber = '';

    contactEmail = '';

    contractId = null;

    employeeId = null;

    callDateTime = new Date();

    jobId = null;

    callNotes = '';

    followUpRequested = false;

    followUpInstructions = '';

    followUpOwnerId = null;
}
